import { useEffect } from 'react';

export const useDashboardGroupToggle = (selector: string): void => {
  useEffect(() => {
    if (!selector || selector.trim() === '') {
      return;
    }

    const onClick = (event: Event) => {
      const target = event.target as HTMLElement | null;
      const opener = target?.closest<HTMLElement>(selector);
      if (!opener) {
        return;
      }

      event.preventDefault();

      const container = opener.closest('li');
      if (!container) {
        return;
      }

      if (container.classList.contains('is-tab') && window.innerWidth >= 480) {
        container.classList.toggle('is-hover');
        return;
      }

      const icon = opener.querySelector('span.item-opener i');
      icon?.classList.toggle('fa-chevron-down');
      icon?.classList.toggle('fa-chevron-up');

      const submenu = opener.nextElementSibling as HTMLElement | null;
      if (!submenu || !submenu.classList.contains('myaccount-submenu')) {
        return;
      }

      const isVisible = window.getComputedStyle(submenu).display !== 'none';
      submenu.style.display = isVisible ? 'none' : 'block';
    };

    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, [selector]);
};
